import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type { OrganisationStructureResponse } from "@/interface/organisation.interface";

export const OrganisationService = {
  getList: async (
    params?: string
  ): Promise<OrganisationStructureResponse> => {
    const url = `${API_ENDPOINT.users}/organisation-structure${params ? `?${params}` : ""}`;
    return callApi<OrganisationStructureResponse>(url, { method: "GET" });
  },
};